import {v4 as uuidv4} from 'uuid';
import {BlockType} from '../block';
import ChemicalEquationBlock = App.Entities.Tasks.Ui.ChemicalEquationBlock;
import ChemicalEquationComponentGrader = App.Entities.Tasks.ComponentGraders.ChemicalEquationComponentGrader;

export const chemicalEquation: BlockType<ChemicalEquationBlock, ChemicalEquationComponentGrader> = {
  translationKey: 'chemical-equation',
  icon: 'flask-empty',
  getName: (block) => block.question,
  sharedValues: ['answer'],
  providesAiContext: true,
  uiConfigFactory: () => ({
    uuid: uuidv4(),
    type: 'ChemicalEquation',
    name: 'Chemical Equation',
    question: '',
    appendText: null,
    prependText: null,
    part: null,
  }),
  componentGraderFactory: (uuid) => ({
    uuid: uuidv4(),
    type: 'ChemicalEquation',
    name: 'Chemical Equation Grader',
    uiComponentUuid: uuid,
    correctEquation: '',
    gradingOptions: [],
  }),
};
